/** @format */

import tw from 'twin.macro';

export const SectionHeading = tw.h2`text-4xl sm:text-4xl font-bold px-1 pt-10 text-center`;
export const Subheading = tw.h5`font-bold text-primary-500 `;
